var viewer_figure_default = {
  "figure": "yMXd0"
};
export {
  viewer_figure_default as default
};
//# sourceMappingURL=viewer-figure-scss.js.map
